import { Component, Input, OnDestroy, OnInit, ChangeDetectorRef } from "@angular/core";
import { DomSanitizer, SafeStyle } from "@angular/platform-browser";
import { Subscription } from "rxjs";
import { GasprecioService } from "src/app/modules/gasprecio/services/gasprecio.service";
import { SharedService } from "src/app/modules/gasprecio/services/shared.service";
import { GroupIds } from "src/app/modules/gasprecio/enums/groups-ids.enum";

@Component({
  selector: 'app-select-station-zone-comparative',
  templateUrl: './select-station-zone-comparative.component.html',
  styleUrls: ['./select-station-zone-comparative.component.scss']
})
export class SelectStationZoneComparativeComponent implements OnInit, OnDestroy {
  @Input() addEmptyStation = true;
  idGroup: GroupIds | string = GroupIds.Pa;
  idGroupSub$!: Subscription;
  public items: any[] = [];
  public stationSelected: any = [];
  public ngxDisabled = true;
  private stationSelected$!: Subscription;
  private zoneSelected$!: Subscription;
  public zoneSelected: string = "";
  private rol!: string | null;
  first = true;

  constructor(
    public sanitizer: DomSanitizer,
    private sharedService: SharedService,
    private gasprecioService: GasprecioService,
    private cdr: ChangeDetectorRef
  ) {
    this.rol = localStorage.getItem("rol");
    this.idGroup = this.rol === "Dios" ? localStorage.getItem("group") || GroupIds.Pa : localStorage.getItem("group") || GroupIds.Pa;
  }

  ngOnInit(): void {
    this.idGroupSub$ = this.sharedService.sharedGroup.subscribe((idGroup) => {
      if (idGroup && idGroup !== this.idGroup) {
        this.idGroup = idGroup;
        this.getStationsGroup();
      }
    });

    this.stationSelected$ = this.sharedService.sharedStation.subscribe((idStation) => {
      if (idStation && idStation !== this.stationSelected) {
        this.stationSelected = idStation;
      }
    });

    this.zoneSelected$ = this.sharedService.sharedZone.subscribe((zone) => {
      if (zone !== undefined) {
        this.zoneSelected = zone;
        this.getStationsGroup();
        this.cdr.detectChanges();
      }
    });
  }

  public style(data: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(data);
  }

  ngOnDestroy(): void {
    this.idGroupSub$.unsubscribe();
    this.stationSelected$.unsubscribe();
    this.zoneSelected$.unsubscribe();
  }

  private updateStationItems(stations: any[]): void {

    this.items = [{ name: "Sin Estación", value: "zone" }];

    this.items.push(...stations.map((element) => ({
      name: this.gasprecioService.capitalizeFirstLetter(element.alias),
      value: element._id,
    })));
  }

  async getStationsGroup(): Promise<void> {
    this.items = [{ name: "Sin Estación", value: "zone" }];
    this.ngxDisabled = true;

    try {
      const data = await this.gasprecioService.getStationsGroupZone(this.idGroup, this.zoneSelected).toPromise();
      this.updateStationItems(data);
      this.ngxDisabled = false;

      if(this.first){
        this.stationSelected = 'zone';
        this.sharedService.nextStationSelected = this.stationSelected;
        this.first = false;
      }else{
        const storedStation = await this.getLocalStorageItem("idStation");
        this.stationSelected = this.stationSelected.length ? this.stationSelected : storedStation;
        this.sharedService.nextStationSelected = this.stationSelected;
      }
    } catch (error) {
      console.error("Error obteniendo estaciones:", error);
    }
  }

  async getLocalStorageItem(key: string): Promise<string | null> {
    return Promise.resolve(localStorage.getItem(key));
  }

  changeStation(event: any): void {
    this.stationSelected = event;
    this.sharedService.nextStationSelected = this.stationSelected;
    this.sharedService.nextStation = this.stationSelected;
  }
}
